// Both CMS renderers render nothing for a `type` they do not recognise, leaving no error and no
// markup. Keyed by renderer + type: warns once per session, not once per render.
const warned = new Set<string>();

export const warnUnrenderableBlockType = (renderer: string, type: string, advice: string): void => {
  if (process.env.NODE_ENV === 'production') return;

  const signature = `${renderer}:${type}`;
  if (warned.has(signature)) return;
  warned.add(signature);

  // eslint-disable-next-line no-console
  console.warn(`[${renderer}] Nothing renders block type "${type}" — it will not appear on the page.\n${advice}`);
};

/** Test seam — the dedupe cache is module-level. */
export const resetUnrenderableBlockTypeWarnings = () => {
  warned.clear();
};
